import React from 'react';
import { Loading, ExperienceEditor } from 'ui';
import { usePage, updatePage, useAuth, useMedia, refreshPagePreview } from 'api';
import { useParams, useHistory } from 'react-router-dom';


export default function EditCampaign(props) {
  
  // Load and Save the template
  
  const auth = useAuth();
  const history = useHistory();
  const companyId = auth ? auth.company.id : null;
  const {pageId} = useParams();
  const page = usePage(companyId, pageId);
  const media = useMedia(auth ? auth.company.id : null);
  
  
  // Save updates 
  
  async function save(update) {
    await updatePage(companyId, pageId, {
      ...update,
    });
    refreshPagePreview(companyId, pageId);
    if(page.campaignId !== "NONE") {
      history.push(`/campaigns/${page.campaignId}`);
    }
    else {
      history.push('/pages');
    }
  }
  
  if(!page) {
    return <Loading/>;
  }
  
  return (
    <ExperienceEditor title={page.name} experience={page} media={media} onSave={save}/>
  );
}